module.exports = __webpack_public_path__ + "img/JPG.17169555.svg";